import { render, staticRenderFns } from "./punch-details.vue?vue&type=template&id=bae89864&scoped=true&"
import script from "./punch-details.vue?vue&type=script&lang=js&"
export * from "./punch-details.vue?vue&type=script&lang=js&"
import style0 from "./punch-details.vue?vue&type=style&index=0&id=bae89864&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bae89864",
  null
  
)

export default component.exports